angular.module('forms').directive('apFormAnswerTimeframe',
    ['aprgettext',
        function (gettext) {
            'use strict';

            return {
                restrict: 'E',
                templateUrl: '/forms/views/directives/apFormAnswerTimeframe.html',
                scope: {
                    // Use '@' for one way binding.  String value is returned.
                    // Use '=' for two way binding.  An object is returned.
                    // Use '&' for a method.
                    form: '=form',
                    question: '=question',
                    lastQuestion: '@lastQuestion'
                },
                controller: function($scope) {
                    var formAnswerChangedListener = null;

                    $scope.timeframeText = {
                        TextPlaceHolder : gettext('Time frame answer here'),
                        TextPlaceHolderRequired : gettext('Required Time Frame answer here')
                    };


                    function formAnswerChanged(eventData) {
                        if ($scope.question.SurveyQuestionId === eventData.QuestionIdToTrigger) {
                            //var formElement = angular.element(document.getElementById($scope.form['SurveyQuestionId_' + $scope.question.SurveyQuestionId]));

                            if (eventData.EnableQuestion === true && $scope.question.QuestionRequireAnswer === true) {
                                //$scope.timeframeText.TextPlaceHolder = gettext('Required Time Frame answer here');
                                //$scope.timeframeText.IsRequired = true;
                                //formElement.$invalid = true;
                            } else {
                                //$scope.timeframeText.TextPlaceHolder = gettext('Time frame answer here');
                                //$scope.timeframeText.IsRequired = false;
                                //formElement.$invalid = false;
                            }
                        }
                    }

                    $scope.$on('$destroy', function() {
                        if (formAnswerChangedListener !== null) {
                            formAnswerChangedListener();
                        }
                    });

                    $scope.answerChanged = function answerChanged() {
                        // Selecting time format radio button handles enabling QuestionsToTrigger
                    };

                    $scope.selectedButtonCallback = function selectedButtonCallback(selectedId) {
                        if (selectedId !== null && selectedId !== undefined) {

                        }
                        //$scope.timeframeText.TextPlaceHolder = gettext('Required Time Frame answer here');
                        //$scope.timeframeText.IsRequired = true;
                    };

                    function loadView() {
                        if ($scope.question.HasAnswersThatTriggerThisQuestion === true) {
                            formAnswerChangedListener = $scope.$on('FormAnswerChanged', function(event, data) {
                                formAnswerChanged(data);
                            });
                        }
                    }
                    loadView();
                }
            };
        }
    ]
);